import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES, ISSUE_STATUSES } from "@miplatform/constants";
import { createUUID } from "@miplatform/utils";
import { filterIssuesWithHistoryOnAttempt } from "../../../../utils";

const getAttemptsGuid = createUUID();

export const useAttemptHistory = ({ stateManager = {} }) => {
  const [attemptList, setAttemptList] = useState([]);

  const getAttempts = async ({ assignmentId }) => {
    stateManager.abort(getAttemptsGuid);
    stateManager.run(async () => {
      const res = await taskService.attempts.getAll({
        filters: {
          assignment: { id: { type: "guid", value: assignmentId } },
        },
        sort: `createdOn desc`,
      });

      if (res.status === HTTP_STATUSES.OK) {
        /**
         * Filter out the issues that where completed in previous attempts
         */
        const attempts = res.data.map((attempt) => {
          const issues = filterIssuesWithHistoryOnAttempt(attempt).map((x) => ({
            ...x,
            status: x.issueResult
              ? x.issueResult?.status ?? ISSUE_STATUSES.REPORTED
              : ISSUE_STATUSES.REPORTED,
          }));
          return { ...attempt, issues };
        });

        setAttemptList(attempts);
      } else {
        setAttemptList([]);
      }
    }, getAttemptsGuid);
  };

  return {
    getAttempts,
    attemptList,
  };
};
